<!-- OutOfStockPopup.svelte -->
<script>
  export let productsNotAdded = [];
  export let onClose;
</script>

<style>
  .popup-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }

  .popup-content {
    background-color: white;
    border-radius: 12px;
    padding: 24px;
    max-width: 80%;
    max-height: 80%;
    overflow-y: auto;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }

  h2 {
    color: #d32f2f;
    margin-top: 0;
    font-size: 24px;
  }

  .product-list {
    margin-top: 16px;
  }

  .product-item {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    padding-bottom: 16px;
    border-bottom: 1px solid #f0f0f0;
  }

  .product-image {
    width: 60px;
    height: 60px;
    object-fit: cover;
    border-radius: 8px;
    margin-right: 16px;
  }

  .product-details {
    flex-grow: 1;
  }

  .product-title {
    font-size: 18px;
    font-weight: 600;
    margin: 0 0 8px 0;
  }

  .product-info {
    font-size: 14px;
    color: #666;
    margin: 0;
  }

  .ok-button {
    background-color: #4caf50;
    color: white;
    border: none;
    padding: 12px 24px;
    font-size: 18px;
    font-weight: 600;
    border-radius: 8px;
    cursor: pointer;
    transition: background-color 0.3s;
    display: block;
    width: 100%;
    margin-top: 24px;
  }

  .ok-button:hover {
    background-color: #45a049;
  }
</style>

<div class="popup-overlay" on:click={onClose}>
  <div class="popup-content" on:click|stopPropagation>
    <h2>Products Out of Stock</h2>
    <p>The following products could not be added to your cart:</p>
    <div class="product-list">
      {#each productsNotAdded as product}
        <div class="product-item">
          <div class="product-details">
            <h3 class="product-title">{product.product__title}</h3>
            <p class="product-info">
              {product.product__unit} {product.product__measurement_unit} • ₹{product.price}
            </p>
            <p class="product-info">Reason: {product.reason}</p>
          </div>
        </div>
      {/each}
    </div>
    <button class="ok-button" on:click={onClose}>It's OK</button>
  </div>
</div>